import { Module } from 'wrapper6'

const $ = jQuery

export default class FilteringActivities extends Module {
  ready (app) {
    $(document).ready(function () {
      let category = ''
      let location = ''
      let year = ''
      let month = ''
      let oldYear = ''
      let oldCategory = ''
      let oldLocation = ''
      const container = $('.activities-container')

      $('#filtering_activities').change(function () {
        category = $(this).find('#category').val()
        location = $(this).find('#location').val()
        year = parseInt($(this).find('#year').val())
        month = parseInt($(this).find('#month').val())

        if (category === default_value) {
          category = ''
        }

        if (location === default_value) {
          location = ''
        }

        if (category !== oldCategory) {
          month = ''
          year = ''
          $('#year').val('')
        }

        if (location !== oldLocation) {
          month = ''
          year = ''
          $('#year').val('')
        }

        if (oldYear !== year) {
          month = ''
          changeMonthSelect()
        }

        filterActivities()
        oldCategory = category
        oldLocation = location
      })

      function filterActivities () {
        const not_empty_months = []
        const not_empty_years = []

        container.find('.activity').each(function () {
          $(this).show()
        })

        if (category) {
          $('.activities-container').find('.activity').each(function () {
            const value = $(this).attr('data-category')

            if (value.indexOf(category) === -1) {
              $(this).hide()
            }
          })
        }

        if (location) {
          $('.activities-container').find('.activity').each(function () {
            const value = $(this).attr('data-location')

            if (value.indexOf(location) === -1) {
              $(this).hide()
            }
          })
        }

        container.find('.activity:visible').each(function () {
          not_empty_years.push($(this).attr('data-year'))
        })

        if (year) {
          container.find('.activity[data-year!="' + year + '"]').each(function () {
            $(this).hide()
          })
        }

        container.find('.activity:visible').each(function () {
          not_empty_months.push($(this).attr('data-month'))
        })

        if (month) {
          $('.activities-container').find('.activity[data-month!="' + month + '"]').each(function () {
            $(this).hide()
          })
        }

        container.find('.activity').css('transition', 'none')
        container.find('.activity').css('-webkit-transition', 'none')

        container.find('.activity:visible').each(function (index) {
          not_empty_months.push($(this).attr('data-month'))

          if (Math.abs(index % 2) == 1) {
            $(this).css('background', '#3e5d58')
          } else {
            $(this).css('background', '#002b49')
          }
        })

        setTimeout(
          function () {
            $('.activities-container').find('.activity').css('transition', 'all 0.6s').delay(1000)
            $('.activities-container').find('.activity').css('-webkit-transition', 'all 0.6s').delay(1000)
          }, 200)

        changeFilterOptions(not_empty_months, not_empty_years)

        addResponseText()
      }

      function addResponseText () {
        const CARDS = container.find('.activity')
        let hasCardVisible = false

        for (let i = 0; i < CARDS.length; i++) {
          const CARD = CARDS[i]

          if ($(CARD).css('display') !== 'none') {
            hasCardVisible = true
          }
        }

        if (!hasCardVisible) {
          if (!$(document).find('.no-posts').length) {
            $('.activities-container').append('<div class="no-posts"> Der er desværre ingen aktiviteter under disse kriterier </div>')
          }
        } else {
          $(document).find('.no-posts').remove()
        }
      }

      function changeFilterOptions (not_empty_months, not_empty_years) {
        $('#month').find('option').each(function () {
          $(this).show()
          const val = $(this).val()

          if (val) {
            if (not_empty_months.indexOf(val) == -1) {
              $(this).hide()
            }
          }
        })

        $('#year').find('option').each(function () {
          $(this).show()
          const val = $(this).val()

          if (val && val !== default_value) {
            if (not_empty_years.indexOf(val) == -1) {
              $(this).hide()
            }
          } else {
            if (category != oldCategory) {
              $(this).remove()
            }

            if (location != oldLocation) {
              $(this).remove()
            }
          }
        })

        if (category != oldCategory) {
          $('#year').prepend('<option selected>' + default_value + '</option>')
        }

        if (location != oldLocation) {
          $('#year').prepend('<option selected>' + default_value + '</option>')
        }
      }

      function changeMonthSelect () {
        $('#month').attr('disabled', isNaN(year) ? 'disabled' : false)

        $('#month').html('<option>' + default_value + '</option>')

        $(months[year]).each(function (index, obj) {
          jQuery.each(obj, function (i, val) {
            $('#month').append($('<option></option>')
              .attr('value', val)
              .text(i))
          })
        })

        oldYear = year
      }
    })
  }
}
